export const PROFESSIONAL_PRICE_USD = 39;
export const PROFESSIONAL_PRICE_CENTS = PROFESSIONAL_PRICE_USD * 100;
export const PROFESSIONAL_PRICE_LABEL = `$${PROFESSIONAL_PRICE_USD}`;
export const PROFESSIONAL_ACCESS_DURATION = "1 year";
export const PROFESSIONAL_OFFER_NAME = "Professional Access";
